import React, { memo, MutableRefObject, useCallback, useState } from 'react';
import { TaxesInfoModal } from './taxes-modal/betslip-taxes-info-modal';
import { sendMessage, SendMessageType } from '@om-fe/core/utils/parent-communication';
import BettingArea, { BettingAreaSsr } from '@om-fe/core/components/betting-area/betting-area';
import DefaultModal, { ModalType } from '@om-fe/core/components/modals/default-modal';
import { BetslipLazy } from '@om-fe/core/core/widgets/retail-widgets/loaders/retail-lazy-loaders';
import getConfig from '@om-fe/core/utils/config';

const enabledBetslipRetail: boolean | undefined = getConfig()?.enabledBetslipRetail;

export interface BetslipOpenBetsProps {
    readonly openModal?: () => void,
    readonly closeModal?: () => void,
    readonly onPlaceBetSuccess?: () => void
    readonly parentContainerRef: MutableRefObject<React.ReactNode>
}

export const BetslipTaxes = memo((
    {
        closeModal,
        openModal,
        parentContainerRef,
        onPlaceBetSuccess,
    }: BetslipOpenBetsProps,
) => {
    const isAppLazy: boolean = getConfig().isAppLazy || false;
    const [showTaxesModal, setShowTaxesModal] = useState<boolean>(false);
    const [showBetbuilderModal, setShowBetbuilderModal] = useState<boolean>(false);
    const [showOddsboostModal, setShowOddsboostModal] = useState<boolean>(false);
    const [sentPlaceBetSuccess, setSentPlaceBetSuccess] = useState<boolean>(false);
    const handleOpenTaxesClick = useCallback(() => {
        setShowTaxesModal(true);
        closeModal?.();
    }, [closeModal]);

    const handleOpenBetbuilderClick = useCallback(() => {
        setShowBetbuilderModal(true);
    }, []);

    const handleOpenOddsboostClick = useCallback(() => {
        setShowOddsboostModal(true);
    }, []);

    const handleCloseTaxesModalClick = useCallback(() => {
        setShowTaxesModal(false);
        openModal?.();
    }, [openModal]);

    const handleCloseBetbuilderModalClick = useCallback(() => {
        setShowBetbuilderModal(false);
    }, []);

    const handleCloseOddsboostModalClick = useCallback(() => {
        setShowOddsboostModal(false);
    }, []);

    const handlePlacedBetSuccess = useCallback(() => {
        if (!sentPlaceBetSuccess) {
            setSentPlaceBetSuccess(true);
            setTimeout(() => {
                setSentPlaceBetSuccess(false);
                onPlaceBetSuccess?.();
                sendMessage({ type: 'OMFE:betPlacedSuccessfully' as SendMessageType });
            }, 2000);
        }
    }, [sentPlaceBetSuccess, setSentPlaceBetSuccess]);

    return (
        <>
            <TaxesInfoModal onClose={handleCloseTaxesModalClick} opened={showTaxesModal} />
            { showBetbuilderModal && <DefaultModal iconType={ModalType.BETBUILDER} hideButtonModal={handleCloseBetbuilderModalClick} />}
            { showOddsboostModal && <DefaultModal iconType={ModalType.ODDSBOOST} hideButtonModal={handleCloseOddsboostModalClick} />}
            {enabledBetslipRetail ? (
                <BetslipLazy />
            ) : (
                (isAppLazy ? <BettingAreaSsr
                    parentContainerRef={parentContainerRef}
                    onPlaceBetSuccess={handlePlacedBetSuccess}
                    onTaxesClick={handleOpenTaxesClick}
                    onBetBuilderIconClick={handleOpenBetbuilderClick}
                    onOddsboostIconClick={handleOpenOddsboostClick}
                    showOddsboostIcon={true}
                    showBannerInGroup={true} />
                    : <BettingArea
                        parentContainerRef={parentContainerRef}
                        onPlaceBetSuccess={handlePlacedBetSuccess}
                        onTaxesClick={handleOpenTaxesClick}
                        onBetBuilderIconClick={handleOpenBetbuilderClick}
                        onOddsboostIconClick={handleOpenOddsboostClick}
                        showOddsboostIcon={true}
                        showBannerInGroup={true}
                    />)
            )}
        </>
    );
});
